import DownloadLink from 'components/DownloadLink';
import {FC} from 'react';
import {t} from 'ttag';

type RegistrationInfoProps = {
    clientName: string;
    email?: string;
    instructionUrl: string | undefined;
    partnerName: string;
};

const RegistrationInfo: FC<RegistrationInfoProps> = ({
    clientName,
    email,
    instructionUrl,
    partnerName,
}) => {
    return (
        <>
            {email && (
                <div>
                    <span className="font-semibold">{t`Email address: `}</span>
                    {email}
                </div>
            )}
            <div>
                <span className="font-semibold">{t`You: `}</span>
                {clientName}
            </div>
            <div>
                <span className="font-semibold">{t`Requestor: `}</span>
                {partnerName}
            </div>
            {instructionUrl && (
                <div>
                    <span className="font-semibold">{t`Requestor’s Instructions: `}</span>
                    <DownloadLink
                        className="mb-1 ml-1"
                        color="green"
                        href={instructionUrl}
                    >
                        <span className="font-semibold">{t`Download here`}</span>
                    </DownloadLink>
                </div>
            )}
        </>
    );
};

export default RegistrationInfo;
